var Enhancer = {};
Enhancer.isProduction = function() {
    return true;
};
Enhancer.getBaseUrl = function() {
	return window.BASE_URL;
};
Enhancer.getCustomInterfaceUrl = function(interfaceName, query) {
    var url = Enhancer.getBaseUrl() + '/custom-interface/call/' + interfaceName;
    if (typeof query === 'object') {
        url = url + '?';
        for (var i in query) {
            url = url + i + '=' + encodeURIComponent(query[i]) + '&';
        }
    }
    return url;
};

var isSmallScreen = $('body').width() < 720;

Enhancer.UA = {
    isMobile: isSmallScreen,
    isDesktop: !isSmallScreen,
    isSmallScreen: isSmallScreen
};

window.Enhancer = Enhancer;

module.exports = Enhancer;


//////////////////
// WEBPACK FOOTER
// ./src/pages/login/enhancer.js
// module id = 3
// module chunks = 0